<template>
    <MainCard>
        <div class="relative flex flex-col items-center justify-center bg-white overflow-hidden">

            <!-- Confetti Canvas -->
            <canvas ref="confettiCanvas" class="absolute inset-0 pointer-events-none"></canvas>

            <!-- Content -->
            <div class="z-10 flex flex-col items-center animate-fade-in">

                <h1 :class="['text-4xl font-bold  mb-2', 'text-' + brandTheme + '-primary']">
                    🎉 {{ $t('celebration.title') }}
                </h1>

                <h2 class="text-xl font-medium text-gray-700 mb-6">
                    {{ $t('celebration.subtitle') }}
                </h2>

                <!-- Gift Box -->
                <div
                    :class="['w-40 h-40 rounded-xl shadow-xl flex flex-col items-center justify-center text-center  text-white text-2xl font-bold', 'bg-' + brandTheme + '-primary']">
                    {{ gift?.name || $t('celebration.gift_placeholder') }} <span>Points Gifty</span>
                </div>

                <!-- Conditional message for physical vs digital -->
                <div v-if="gift?.type === 'physical'" class="mt-4 text-center text-gray-700">
                    {{ $t('celebration.physical_message') }}
                </div>

                <div v-else class="mt-4 text-center text-gray-700 flex flex-col items-center">
                    {{ $t('celebration.digital_message') }}
                    <a class="mt-3 px-4 py-2 bg-gradient-to-br from-gifty-pink to-gifty-pink_dark text-white font-medium rounded-lg mb-2 shadow"
                        @click="downloadGiftApp" href="https://play.google.com/store/apps/details?id=com.gifty.pro.android">
                        {{ $t('celebration.download_app_button') }}
                </a>
                </div>



            </div>
        </div>
    </MainCard>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useParticipationStore } from '@/stores/useParticipationStore'
import MainCard from '@/components/mainCard.vue'

const participationStore = useParticipationStore()

const gift = computed(() => {
    return participationStore.gifts.find(g => g.id === participationStore.participation.gift_id)
})

const confettiCanvas = ref(null)

// --- Confetti Animation ---
const brandTheme = ref('')
onMounted(() => {
    brandTheme.value = participationStore.participation?.brand ?? 'cocacola';

    startConfetti()
})

function startConfetti() {
    const canvas = confettiCanvas.value
    const ctx = canvas.getContext("2d")

    canvas.width = window.innerWidth
    canvas.height = window.innerHeight

    const colors = ["#FF3B30", "#FF9500", "#FFCC00", "#4CD964", "#5AC8FA", "#007AFF", "#5856D6"]

    const confettis = Array.from({ length: 150 }).map(() => ({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height - canvas.height,
        r: Math.random() * 6 + 4,
        color: colors[Math.floor(Math.random() * colors.length)],
        speed: Math.random() * 3 + 2,
    }))

    function update() {
        ctx.clearRect(0, 0, canvas.width, canvas.height)

        confettis.forEach((c) => {
            c.y += c.speed
            if (c.y > canvas.height) {
                c.y = -10
                c.x = Math.random() * canvas.width
            }

            ctx.fillStyle = c.color
            ctx.fillRect(c.x, c.y, c.r, c.r)
        })

        requestAnimationFrame(update)
    }

    update()
}


const downloadGiftApp = () => {
    // e.g., window.open("https://giftapp.example.com", "_blank")
}
</script>

<style scoped>
@keyframes fade-in {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.animate-fade-in {
    animation: fade-in 0.8s ease-out forwards;
}
</style>
